import React, { Children } from 'react'
import PropTypes from 'prop-types'
import { colors } from 'config/ui'
import { StyledButton, Loading } from './Button.styles'
import { Spinner } from 'components/lib/loaders'

const Button = ({
  newSize = undefined,
  color = undefined,
  primary = undefined,
  outline = undefined,
  fluid = undefined,
  size = undefined,
  disabled = undefined,
  loading = undefined,
  sharpBorders = undefined,
  justifyContent = undefined,
  children = undefined,
  ...rest
}) => (
  <StyledButton
    type="button"
    color={primary ? colors.primary : color || colors.gray}
    newSize={newSize}
    outline={outline}
    sharpBorders={sharpBorders}
    fluid={fluid}
    size={size}
    disabled={loading || disabled}
    justifyContent={justifyContent}
    multipleChildren={Children.count(children) > 1}
    {...rest}
  >
    {loading && (
      <Loading
        sharpBorders={sharpBorders}
        color={primary ? colors.primary : color || colors.gray}
      >
        <Spinner />
      </Loading>
    )}
    {children}
  </StyledButton>
)

export const buttonPropTypes = {
  color: PropTypes.string,
  primary: PropTypes.bool,
  outline: PropTypes.bool,
  fluid: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  sharpBorders: PropTypes.bool,
  size: PropTypes.oneOf(['x-small', 'small', 'medium', 'big']),
  newSize: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
  noTextTransform: PropTypes.bool,
  textColor: PropTypes.string,
  textColorHover: PropTypes.string,
  justifyContent: PropTypes.string
}

Button.propTypes = buttonPropTypes

Button.defaultProps = {
  size: 'medium'
}

export default Button
